import * as React from "react";
import * as yup from "yup";
import * as Comp from "../../../components";
import { ComponentWithValidatedForm } from "../../../components/validation";
import * as M from "../../../models";
import { Api } from "../../../services/Api";

interface OwnProps {
    api: Api;
    onComplete: (tag: M.Tag.TagAdmin, isNew: boolean) => void;
}

interface OwnState {
    tag?: M.Tag.TagAdmin;
    show: boolean;
}

interface TagEditData {
    id: number;
    name: string;
}

class TagEdit implements M.Validation.FormValidationModel<TagEditData> {
    public data: TagEditData;
    public rules: yup.Schema<TagEditData>;

    public constructor() {
        this.data = {
            id: 0,
            name: "",
        };
        this.rules = yup.object<TagEditData>().shape({
            id: yup.number().min(0, "Invalid $label").label("ID"),
            name: yup.string().required().max(150).label("Name"),
        });
    }
}

export class TagEditModal extends ComponentWithValidatedForm<OwnProps, OwnState> {

    private _isMounted = false;

    public constructor(props: any) {
        super(props);

        const formModel = new TagEdit();
        this.state = {
            ...this.getInitialState(formModel),
            show: false,
        };
    }

    public componentDidMount() {
        this._isMounted = true;
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public close() {
        this.setState({ ...this.state, show: false });
    }

    public show(tag?: M.Tag.TagAdmin) {
        const formModel = new TagEdit();

        if (tag) {
            formModel.data.id = tag.id;
            formModel.data.name = tag.name;
        }

        this.setState({ ...this.state,
            ...this.getInitialState(formModel),
            tag,
            show: true,
        });
    }

    public render() {
        const formModel = this.getFormModelData<TagEditData>();

        return <Comp.Modal.ModalForm
            formComponent={this}
            onCancel={() => this.close()}
            processing={this.state.formProcessing}
            show={this.state.show}
            title={formModel.id === 0 ? "Add tag" : `Edit \"${formModel.name}\"`}
        >
            <Comp.Validation.ValidatedForm
                formComponent={this}
                model={this.state.formModel.data}
                onValidSubmit={(model) => this.onSubmit(model)}
                schema={this.state.formModel.rules}
                ref={(ref: any) => this.form = ref}
            >

                <Comp.Editors.TextField formComponent={this} name="name" compact css="txt" />

            </Comp.Validation.ValidatedForm>
        </Comp.Modal.ModalForm>;
    }

    private async onSubmit(model: TagEditData) {
        this.toggleProcessing(true);

        const id = model.id;
        const result = await this.props.api.post<any>(Api.endpoints.admin.tag.tag.withUrlParams({ id }), {
            body: JSON.stringify({
                id: model.id,
                name: model.name,
            }),
        });

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.close();
            this.props.onComplete(result.data, model.id === 0);
        }
        else {
            this.setFormErrors(M.Result.Result.errorsOrMessage(result));
        }

        this.toggleProcessing(false);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminTag/components/TagEditModal.tsx